/* eslint-disable  */

import { gql } from "@apollo/client";

// Role Management

export const GET_ALL_ROLES = gql`
  query Roles(
    $orderBy: RoleOrderByInput!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $filters: RoleWhereInput
  ) {
    roles(
      orderBy: $orderBy
      after: $after
      before: $before
      first: $first
      last: $last
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          name
          isActive
          permissions {
            Admin { READ WRITE }
            Roles { READ WRITE }
            Users { READ WRITE }
            Subscription { READ WRITE }
            Course { READ WRITE }
            Template { READ WRITE }
            Dashboard { READ WRITE }
          }
          createdBy {
            id
            fullName
            email
            createdAt
            isBanned
          }
          createdAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_NEXT_ROLES_PAGE = gql`
  query Permissions(
    $first: Int
    $after: String
    $filters: RoleWhereInput
    $orderBy: RoleOrderByInput!
  ) {
    roles(first: $first, after: $after, filters: $filters, orderBy: $orderBy) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          id
          name
          isActive
           permissions {
            Admin { READ WRITE }
            Roles { READ WRITE }
            Users { READ WRITE }
            Subscription { READ WRITE }
            Course { READ WRITE }
            Template { READ WRITE }
            Dashboard { READ WRITE }
          }
          createdBy {
            id
            fullName
            email
            createdAt
            isBanned
          }
          createdAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_PREV_ROLES_PAGE = gql`
  query Permissions(
    $last: Int
    $before: String
    $filters: RoleWhereInput
    $orderBy: RoleOrderByInput!
  ) {
    roles(last: $last, before: $before, filters: $filters, orderBy: $orderBy) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          id
          name
          isActive
           permissions {
            Admin { READ WRITE }
            Roles { READ WRITE }
            Users { READ WRITE }
            Subscription { READ WRITE }
            Course { READ WRITE }
            Template { READ WRITE }
            Dashboard { READ WRITE }
          }
          createdBy {
            id
            fullName
            email
            createdAt
            isBanned
          }
          createdAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const VIEW_ROLE = gql`
  query Query($roleId: String!) {
    role(id: $roleId) {
      id
      name
      isActive
      isBanned
      createdAt
      createdBy {
        id
        fullName
      }
      permissions {
        Admin { READ WRITE }
        Roles { READ WRITE }
        Users { READ WRITE }
        Subscription { READ WRITE }
        Course { READ WRITE }
        Template { READ WRITE }
        Dashboard { READ WRITE }
      }
    }
  }
`;

export const GET_ROLE_DETAILS = gql`
  query Role($roleId: String!) {
    role(id: $roleId) {
      id
      name
      isActive
      createdAt
      createdBy {
        id
        fullName
      }
      permissions {
        Admin { READ WRITE }
        Roles { READ WRITE }
        Users { READ WRITE }
        Subscription { READ WRITE }
        Course { READ WRITE }
        Template { READ WRITE }
        Dashboard { READ WRITE }
      }
    }
  }
`;

export const GET_DASHBOARD_DATA = gql`
  query Dashboard {
    dashboard {
      message
      status
      userdata
      projectData
      trackData
      subscription
      ipfsStorage
      dropboxStorage
      driveStorage
      totalRevenue
      monthlyRevenue
    }
  }
`;

export const GET_CAMAROO_DASHBOARD_DATA = gql`
  query Dashboard {
    dashboard {
      message
      status
      totalUsers
      totalPortfolios
      totalOpportunities
      totalSubscriptions
      totalCoursePurchases
    }
  }
`;

export const SEARCH_ROLE = gql`
  query Query($filters: RoleWhereInput, $first: Int) {
    roles(filters: $filters, first: $first) {
      edges {
        cursor
        node {
          id
          name
          createdAt
          createdBy {
            fullName
            email
          }
          isActive
          permissions {
            Admin { READ WRITE }
            Roles { READ WRITE }
            Users { READ WRITE }
            Subscription { READ WRITE }
            Course { READ WRITE }
            Template { READ WRITE }
            Dashboard { READ WRITE }
          }
        }
      }
    }
  }
`;

// Admin Management

export const GET_ALL_ADMINS = gql`
  query Admins(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $orderBy: AdminOrderByInput!
    $filters: AdminsWhereInput
  ) {
    admins(
      after: $after
      before: $before
      first: $first
      last: $last
      orderBy: $orderBy
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          fullName
          email
          countryCode
          mobile
          isActive
          role {
            id
            name
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GET_NEXT_ADMINS_PAGE = gql`
  query Admins(
    $orderBy: AdminOrderByInput!
    $first: Int
    $after: String
    $filters: AdminsWhereInput
  ) {
    admins(orderBy: $orderBy, first: $first, after: $after, filters: $filters) {
      edges {
        cursor
        node {
          id
          fullName
          email
          mobile
          countryCode
          profilePic
          role {
            id
            name
            isActive
          }
          createdAt
          isActive
          isVerified
          isBlocked
          isBanned
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_PREV_ADMINS_PAGE = gql`
  query Admins(
    $orderBy: AdminOrderByInput!
    $last: Int
    $before: String
    $filters: AdminsWhereInput
  ) {
    admins(orderBy: $orderBy, last: $last, before: $before, filters: $filters) {
      edges {
        cursor
        node {
          id
          fullName
          email
          mobile
          countryCode
          profilePic
          role {
            id
            name
            isActive
          }
          createdAt
          isActive
          isVerified
          isBlocked
          isBanned
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const VIEW_ADMIN = gql`
  query Admin($adminId: String!) {
    admin(id: $adminId) {
      id
      fullName
      email
      permissions {
        Admin { READ WRITE }
        Roles { READ WRITE }
        Users { READ WRITE }
        Subscription { READ WRITE }
        Course { READ WRITE }
        Template { READ WRITE }
        Dashboard { READ WRITE }
      }
      mobile
      countryCode
      profilePic
      role {
        id
        name
        isActive
        createdAt
        permissions {
          Admin { READ WRITE }
          Roles { READ WRITE }
          Users { READ WRITE }
          Subscription { READ WRITE }
          Course { READ WRITE }
          Template { READ WRITE }
          Dashboard { READ WRITE }
        }
      }
      createdBy {
        id
        fullName
      }
      createdAt
      isActive
      isBanned
    }
  }
`;

export const GET_ADMIN_DETAILS = gql`
  query Admin($adminId: String!) {
    admin(id: $adminId) {
      id
      fullName
      email
      permissions {
        Admin { READ WRITE }
        Roles { READ WRITE }
        Users { READ WRITE }
        Subscription { READ WRITE }
        Course { READ WRITE }
        Template { READ WRITE }
        Dashboard { READ WRITE }
      }
      mobile
      countryCode
      profilePic
      role {
        id
        name
        isActive
        createdAt
        permissions {
          Admin { READ WRITE }
          Roles { READ WRITE }
          Users { READ WRITE }
          Subscription { READ WRITE }
          Course { READ WRITE }
          Template { READ WRITE }
          Dashboard { READ WRITE }
        }
      }
      createdBy {
        id
        fullName
      }
      createdAt
      isActive
      isBanned
    }
  }
`;

export const SEARCH_ADMIN = gql`
  query Admins($orderBy: AdminOrderByInput!, $first: Int) {
    admins(orderBy: $orderBy, first: $first) {
      edges {
        cursor
        node {
          id
          fullName
          email
          mobile
          countryCode
          profilePic
          role {
            id
            name
            isActive
            permissions {
            Admin { READ WRITE }
            Roles { READ WRITE }
            Users { READ WRITE }
            Subscription { READ WRITE }
            Course { READ WRITE }
            Template { READ WRITE }
            Dashboard { READ WRITE }
          }
          }
          createdAt
          isActive
          isVerified
          isBlocked
          isBanned
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

// Admin Profile

export const ADMIN_PROFILE = gql`
  query Me {
    me {
      id
      fullName
      email
      mobile
      countryCode
      createdAt
      role {
        name
      }
    }
  }
`;

// Category Management
export const GET_ALL_CATEGORIES = gql`
  query Query(
    $first: Int
    $filters: CategoryWhereInput
    $orderBy: CategoryOrderByInput!
  ) {
    categories(first: $first, filters: $filters, orderBy: $orderBy) {
      edges {
        node {
          id
          name
          createdAt
          description
          createdBy {
            fullName
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_NEXT_CATEGORIES = gql`
  query Query(
    $first: Int
    $filters: CategoryWhereInput
    $orderBy: CategoryOrderByInput!
    $after: String
  ) {
    categories(
      first: $first
      filters: $filters
      orderBy: $orderBy
      after: $after
    ) {
      edges {
        node {
          id
          name
          createdAt
          description
          createdBy {
            fullName
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_PREV_CATEGORIES = gql`
  query Query(
    $first: Int
    $filters: CategoryWhereInput
    $orderBy: CategoryOrderByInput!
    $before: String
  ) {
    categories(
      first: $first
      filters: $filters
      orderBy: $orderBy
      before: $before
    ) {
      edges {
        node {
          id
          name
          createdAt
          description
          createdBy {
            fullName
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

// User management
export const GET_ALL_USERS_ADMIN = gql`
  query Users(
    $orderBy: UserOrderByInput!
    $first: Int
    $filters: UsersWhereInput
    $after: String
    $before: String
    $last: Int
  ) {
    users(
      orderBy: $orderBy
      first: $first
      filters: $filters
      after: $after
      before: $before
      last: $last
    ) {
      edges {
        node {
          id
          email
          createdAt
          name
          wallets {
            addr
            provider
          }
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;
export const GET_ALL_USERS = gql`
  query Users(
    $orderBy: UserOrderByInput!
    $first: Int
    $filters: UsersWhereInput
  ) {
    users(orderBy: $orderBy, first: $first, filters: $filters) {
      edges {
        cursor
        node {
          id
          fullName
          username
          email
          description
          mobile
          address
          countryCode
          profilePic
          coverPic
          wallet
          createdAt
          socialLinks {
            facebook
            twitter
            instagram
            blog
            website
            discord
          }
          isVerified
          isBlocked
          isBanned
          isProfileDetailsUpdated
          isWhitelisted
          isRequestForwhitelist
          isCollectionAccess
          collectionAccessStatus
          rejectReason
          isRequestedCollectionAccess
          tags
          totalVolume
          totalCollections
          totalNfts
          floorPrice
          isPublic
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;
export const VIEW_USER = gql`
  query User($userId: String!) {
    user(id: $userId) {
      user {
        id
        fullName
        name
        email
        mobile
        isBanned
        wallets {
          addr
          provider
        }
        profile_img
      }
      totalProject
      totalMusicTracks
      storage
      projectList {
        name
        music
        minted_music
        createdAt
        updatedAt
        collaborations {
          invitedForProject
          roles
          user
          permission
          split
          accepted
        }
      }
    }
  }
`;

export const GET_ALL_USERS_ADMIN_NEXT = gql`
  query Users(
    $orderBy: UserOrderByInput!
    $first: Int
    $filters: UsersWhereInput
    $after: String
  ) {
    users(orderBy: $orderBy, first: $first, filters: $filters, after: $after) {
      edges {
        node {
          id
          email
          createdAt
          name
          wallets {
            addr
            provider
          }
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;
export const GET_ALL_USERS_ADMIN_PREV = gql`
  query Users(
    $orderBy: UserOrderByInput!
    $filters: UsersWhereInput
    $before: String
    $last: Int
  ) {
    users(orderBy: $orderBy, filters: $filters, before: $before, last: $last) {
      edges {
        node {
          id
          email
          createdAt
          name
          wallets {
            addr
            provider
          }
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const INVITE_USER_LIST = gql`
  query InviteUserList(
    $orderBy: InviteUserOrderByInput!
    $filters: InviteUserWhereInput
    $last: Int
    $first: Int
    $before: String
    $after: String
  ) {
    inviteUserList(
      orderBy: $orderBy
      filters: $filters
      last: $last
      first: $first
      before: $before
      after: $after
    ) {
      edges {
        cursor
        node {
          id
          email
          status
          createdAt
          updatedAt
          userId {
            username
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_NEXT_USERS = gql`
  query Query(
    $orderBy: UserOrderByInput!
    $first: Int
    $filters: UsersWhereInput
    $after: String
  ) {
    users(orderBy: $orderBy, first: $first, filters: $filters, after: $after) {
      edges {
        cursor
        node {
          id
          fullName
          username
          email
          description
          mobile
          address
          countryCode
          profilePic
          coverPic
          wallet
          createdAt
          socialLinks {
            facebook
            twitter
            instagram
            blog
            website
            discord
          }
          isVerified
          isBlocked
          isBanned
          isProfileDetailsUpdated
          isWhitelisted
          isRequestForwhitelist
          isCollectionAccess
          collectionAccessStatus
          rejectReason
          isRequestedCollectionAccess
          tags
          totalVolume
          totalCollections
          totalNfts
          floorPrice
          isPublic
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;
export const GET_PREV_USERS = gql`
  query Query(
    $orderBy: UserOrderByInput!
    $last: Int
    $filters: UsersWhereInput
    $before: String
  ) {
    users(orderBy: $orderBy, last: $last, filters: $filters, before: $before) {
      edges {
        cursor
        node {
          id
          fullName
          username
          email
          description
          mobile
          address
          countryCode
          profilePic
          coverPic
          wallet
          createdAt
          socialLinks {
            facebook
            twitter
            instagram
            blog
            website
            discord
          }
          isVerified
          isBlocked
          isBanned
          isProfileDetailsUpdated
          isWhitelisted
          isRequestForwhitelist
          isCollectionAccess
          collectionAccessStatus
          rejectReason
          isRequestedCollectionAccess
          tags
          totalVolume
          totalCollections
          totalNfts
          floorPrice
          isPublic
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

// Platform Variables

export const GET_ALL_PLATFORM_VARIABLES = gql`
  query Query {
    variables {
      variables {
        isActive
        name
        value
      }
      id
    }
  }
`;
export const GET_ALL_FEATURED_COLLECTION = gql`
  query Collections(
    $orderBy: CollectionOrderByInput!
    $first: Int
    $filters: CollectionWhereInput
  ) {
    collections(orderBy: $orderBy, first: $first, filters: $filters) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          id
          name
          description
        }
      }
    }
  }
`;
export const GET_NEXT_FEATURED_COLLECTION = gql`
  query Collections(
    $orderBy: CollectionOrderByInput!
    $first: Int
    $filters: CollectionWhereInput
    $after: String
  ) {
    collections(
      orderBy: $orderBy
      first: $first
      filters: $filters
      after: $after
    ) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          id
          name
          description
        }
      }
    }
  }
`;
export const GET_PREV_FEATURED_COLLECTION = gql`
  query Collections(
    $orderBy: CollectionOrderByInput!
    $first: Int
    $filters: CollectionWhereInput
    $before: String
  ) {
    collections(
      orderBy: $orderBy
      first: $first
      filters: $filters
      before: $before
    ) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          id
          name
          description
        }
      }
    }
  }
`;
export const SEARCH_COLLECTIONS = gql`
  query Collections(
    $orderBy: CollectionOrderByInput!
    $first: Int
    $filters: CollectionWhereInput
  ) {
    collections(orderBy: $orderBy, first: $first, filters: $filters) {
      edges {
        cursor
        node {
          id
          name
        }
      }
    }
  }
`;

// Import Collection

export const GET_ALL_IMPORT_COLLECTION_REQUEST = gql`
  query Forms($orderBy: FormOrderByInput!, $first: Int) {
    forms(orderBy: $orderBy, first: $first) {
      edges {
        node {
          id
          collectionName
          collectionAddress
          collectionTotalNFTCount
          ownerAddress
          category {
            name
          }
          status
          isDeleted
          pendingNFTs
          collectionDescription
          collectionLinkExampleUri
          contactInfo
          avatar
          backgroundImg
        }
        cursor
      }
      pageInfo {
        endCursor
        startCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
`;

export const GET_NEXT_IMPORT_COLLECTION_REQUEST = gql`
  query Forms($orderBy: FormOrderByInput!, $first: Int, $after: String) {
    forms(orderBy: $orderBy, first: $first, after: $after) {
      edges {
        node {
          id
          collectionName
          collectionAddress
          collectionTotalNFTCount
          ownerAddress
          category {
            name
          }
          status
          isDeleted
          pendingNFTs
          collectionDescription
          collectionLinkExampleUri
          contactInfo
          avatar
          backgroundImg
        }
        cursor
      }
      pageInfo {
        endCursor
        startCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
`;

export const GET_PREV_IMPORT_COLLECTION_REQUEST = gql`
  query Forms($orderBy: FormOrderByInput!, $first: Int, $before: String) {
    forms(orderBy: $orderBy, first: $first, before: $before) {
      edges {
        node {
          id
          collectionName
          collectionAddress
          collectionTotalNFTCount
          ownerAddress
          category {
            name
          }
          status
          isDeleted
          pendingNFTs
          collectionDescription
          collectionLinkExampleUri
          contactInfo
          avatar
          backgroundImg
        }
        cursor
      }
      pageInfo {
        endCursor
        startCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
`;

export const VIEW_COLLECTION_REQUEST = gql`
  query Form($formId: String!) {
    form(id: $formId) {
      id
      collectionName
      collectionAddress
      collectionTotalNFTCount
      ownerAddress
      category {
        name
      }
      owner {
        username
      }
      createdAt
      status
      isDeleted
      pendingNFTs
      collectionDescription
      collectionLinkExampleUri
      contactInfo
      avatar
      backgroundImg
    }
  }
`;

// Collectibles
export const GET_COLLECTIBLES = gql`
  query Items($orderBy: ItemOrderByInput!, $first: Int) {
    items(orderBy: $orderBy, first: $first) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          id
          currentOwner {
            wallet
            id
          }
          createdBy {
            wallet
            id
          }
          tokenId
          title
          collection {
            name
          }
          nftType
          isImportedNFT
        }
      }
    }
  }
`;

export const GET_NEXT_COLLECTIBLES = gql`
  query Items($orderBy: ItemOrderByInput!, $first: Int, $after: String) {
    items(orderBy: $orderBy, first: $first, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          id
          currentOwner {
            wallet
            id
          }
          createdBy {
            wallet
            id
          }
          tokenId
          title
          collection {
            name
          }
          nftType
          isImportedNFT
        }
      }
    }
  }
`;

export const GET_PREV_COLLECTIBLES = gql`
  query Items($orderBy: ItemOrderByInput!, $first: Int, $before: String) {
    items(orderBy: $orderBy, first: $first, before: $before) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          id
          currentOwner {
            wallet
            id
          }
          createdBy {
            wallet
            id
          }
          tokenId
          title
          collection {
            name
          }
          nftType
          isImportedNFT
        }
      }
    }
  }
`;

export const VIEW_COLLECTIBLE = gql`
  query Item($itemId: String!) {
    item(id: $itemId) {
      id
      title
      description
      tokenId
      mediaUrl
      previewImage
      collection {
        name
      }
      currentOwner {
        wallet
      }
      nftContractAddress
      royalties
      numberOfCopies
      properties {
        trait_type
        value
      }
      tokenUri
      isBlockchainVerified
      blockchainCurrency
      initialPrice
      isUnlockable
      unlockableContent
      isAdultContent
      isBlackListed
      isActive
      isDeleted
      createdBy {
        wallet
      }
      status
      blockchainItemId
      isImportedNFT
    }
  }
`;

//CMS Queries
export const GET_ALL_CMS = gql`
  query Query {
    getAllCms {
      content
      createdAt
      id
      tab
      title
      updatedAt
    }
  }
`;

export const GET_CMS_BY_TAB = gql`
  query GetCmsByTab($tab: CmsTab!) {
    getCmsByTab(tab: $tab) {
      content
      createdAt
      id
      tab
      title
      updatedAt
    }
  }
`;

export const GET_TRANSACTION_DATA = gql`
  query Transactions(
    $orderBy: TransactionOrderByInput!
    $filters: TransactionWhereInput
    $first: Int
    $last: Int
    $before: String
    $after: String
  ) {
    transactions(
      orderBy: $orderBy
      filters: $filters
      first: $first
      last: $last
      before: $before
      after: $after
    ) {
      message
      status
      edges {
        cursor
        node {
          token {
            name
            symbol
            price
            amount
            transactionFee
            transactionHash
            transferStatus
          }
          gift {
            token {
              transferFailureReason
              transactionHash
              symbol
              name
              amount
              transferStatus
            }
          }
          _id
          _account
          wallet
          paymentType
          amount
          currency
          customerId
          paymentId
          paymentIdClientSecret
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_TRANSACTION_DATA_PREV = gql`
  query Transactions(
    $orderBy: TransactionOrderByInput!
    $filters: TransactionWhereInput
    $first: Int
    $last: Int
    $before: String
    $after: String
  ) {
    transactions(
      orderBy: $orderBy
      filters: $filters
      first: $first
      last: $last
      before: $before
      after: $after
    ) {
      message
      status
      edges {
        cursor
        node {
          token {
            name
            symbol
            price
            amount
            transactionFee
            transactionHash
            transferStatus
          }
          _id
          _account
          wallet
          paymentType
          amount
          currency
          customerId
          paymentId
          paymentIdClientSecret
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;
export const GET_TRANSACTION_DATA_NEXT = gql`
  query Transactions(
    $orderBy: TransactionOrderByInput!
    $filters: TransactionWhereInput
    $first: Int
    $last: Int
    $before: String
    $after: String
  ) {
    transactions(
      orderBy: $orderBy
      filters: $filters
      first: $first
      last: $last
      before: $before
      after: $after
    ) {
      message
      status
      edges {
        cursor
        node {
          token {
            name
            symbol
            price
            amount
            transactionFee
            transactionHash
            transferStatus
          }
          _id
          _account
          wallet
          paymentType
          amount
          currency
          customerId
          paymentId
          paymentIdClientSecret
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const SUBSCRIPTION_FEATURES = gql`
  query SubscriptionFeatures {
    subscriptionFeatures {
      features {
        id
        name
        unit
        limit
        description
        not_available_description
      }
    }
  }
`;

export const GET_SUBSCRIPTIONS = gql`
  query Subscriptions(
    $orderBy: SubscriptionOrderByInput!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $filters: SubscriptionWhereInput
  ) {
    subscriptions(
      orderBy: $orderBy
      after: $after
      before: $before
      first: $first
      last: $last
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          coinflowPlanId
          name
          planCode
          description
          type
          price
          interval
          duration
          currency
          features {
            featureKey
            description
            not_available_description
            available
            limit
            unit
          }
          status
          createdById
          updatedById
          createdAt
          updatedAt
          isDeleted
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_SUBSCRIPTION_BY_ID = gql`
  query Subscription($subscriptionId: String!) {
    subscription(id: $subscriptionId) {
      id
      coinflowPlanId
      name
      planCode
      description
      type
      price
      interval
      duration
      currency
      features {
        featureKey
        description
        not_available_description
        available
        limit
        unit
      }
      status
      createdById
      updatedById
      createdAt
      updatedAt
      isDeleted
    }
  }
`;

export const GET_DISTROLIST = gql`
  query DistroList(
    $orderBy: DistroOrderByInput!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $filters: DistroWhereInput
  ) {
    distroList(
      orderBy: $orderBy
      after: $after
      before: $before
      first: $first
      last: $last
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          userId {
            id
            fullName
            username
            name
            email
          }
          message
          status
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_DISTRO_BY_ID = gql`
  query Distro($distroId: String!) {
    distro(id: $distroId) {
      id
      userId {
        id
        fullName
        username
        name
        email
        description
        mobile
        address
        countryCode
        profilePic
        coverPic
        wallet
        profile_img
        createdAt
        socialLinks {
          facebook
          twitter
          instagram
          blog
          website
          discord
        }
        isVerified
        isBlocked
        isBanned
        isProfileDetailsUpdated
        isWhitelisted
        isRequestForwhitelist
        isCollectionAccess
        collectionAccessStatus
        rejectReason
        isRequestedCollectionAccess
        tags
        totalVolume
        totalCollections
        totalNfts
        floorPrice
        isPublic
        wallets {
          addr
          provider
        }
      }
      spotify
      youtube
      userName
      tiktok
      apple
      instagram
      x
      message
      status
      createdAt
      updatedAt
    }
  }
`;

export const GET_GAMIFICATION_LIST = gql`
  query GamificationList(
    $orderBy: GamificationOrderByInput!
    $first: Int
    $after: String
    $before: String
  ) {
    gamificationList(
      orderBy: $orderBy
      first: $first
      after: $after
      before: $before
    ) {
      edges {
        cursor
        node {
          id
          occurrence
          points
          identifier
          name
          isActive
          createdById {
            id
            fullName
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_GAMIFICATION_BY_ID = gql`
  query Gamification($gamificationId: String!) {
    gamification(id: $gamificationId) {
      id
      occurrence
      points
      identifier
      name
      isActive
      createdById {
        id
        fullName
        profilePic
      }
    }
  }
`;

export const GET_USER_ACTIVITY_LIST = gql`
  query Leaderboard(
    $orderBy: LeaderboardOrderByInput!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $filters: LeaderboardWhereInput
  ) {
    leaderboard(
      orderBy: $orderBy
      after: $after
      before: $before
      first: $first
      last: $last
      filters: $filters
    ) {
      edges {
        cursor
        node {
          _id
          userId {
            id
            fullName
            username
            name
            email
          }
          questPerformed
          questPoints
          eventPerformed
          eventPoints
          points
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_RELEASE_LIST = gql`
  query ReleaseList(
    $orderBy: ReleaseOrderByInput!
    $last: Int
    $first: Int
    $after: String
    $before: String
    $filters: ReleaseWhereInput
  ) {
    releaseList(
      orderBy: $orderBy
      last: $last
      first: $first
      after: $after
      before: $before
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          userId
          projectId
          isSendForRelease
          track {
            artist
            language
            trackId
          }
          artist {
            performerCredit
            writeCredit
            additionalCredit
            role
            genre
          }
          collaborators {
            userName
            userImage
            splitValue
            walletAddress
            id
          }
          trackMetadata {
            labelName
            copyrightName
            copyrightYear
            countryOfRecording
            trackISRC
            lyrics
          }
          ownership {
            ownership
            territories
          }
          compositionRights {
            composerName
            percentageOfOwnership
            rightsManagement
          }
          releaseStatus {
            previouslyReleased
            upc
            releaseDate
          }
          createdAt
          updatedAt
          trackId {
            id
            name
            extension
            size
            duration
            imageWaveBig
            imageWaveSmall
            metadata_id
            createdAt
            updatedAt
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_RELEASE_BY_ID = gql`
  query Release($releaseId: String!) {
    release(id: $releaseId) {
      metadata {
        id
        userId
        projectId
        isSendForRelease
        track {
          artist
          language
          trackId
        }
        artist {
          performerCredit
          writeCredit
          additionalCredit
          role
          genre
        }
        collaborators {
          userName
          userImage
          splitValue
          walletAddress
          id
        }
        trackMetadata {
          labelName
          copyrightName
          copyrightYear
          countryOfRecording
          trackISRC
          lyrics
        }
        ownership {
          ownership
          territories
        }
        compositionRights {
          composerName
          percentageOfOwnership
          rightsManagement
        }
        releaseStatus {
          previouslyReleased
          upc
          releaseDate
        }
        createdAt
        updatedAt
        trackId {
          id
          name
          extension
          size
          duration
          imageWaveBig
          imageWaveSmall
          metadata_id
          createdAt
          updatedAt
        }
      }
      audioUrl
    }
  }
`;

export const GET_QUEST_LIST = gql`
  query QuestList(
    $orderBy: QuestOrderByInput!
    $filters: QuestWhereInput
    $last: Int
    $first: Int
    $before: String
    $after: String
  ) {
    questList(
      orderBy: $orderBy
      filters: $filters
      last: $last
      first: $first
      before: $before
      after: $after
    ) {
      edges {
        cursor
        node {
          id
          occurrence
          points
          identifier
          isPublished
          name
          isPublishByAdmin
          isActive
          description
          metaData {
            caption
            mentions
            hashtags
          }
          createdById {
            id
            fullName
            createdAt
            isActive
            isVerified
            isBlocked
            isBanned
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const AIRDROP_LIST = gql`
  query AirdropList($orderBy: AirdropOrderByInput!, $first: Int, $after: String, $last: Int, $before: String, $filters: AirdropWhereInput) {
    airdropList(orderBy: $orderBy, first: $first, after: $after, last: $last, before: $before, filters: $filters) {
      edges {
        cursor
        node {
          id
          guildedNftId {
            id
            listingId
            tokenId
            title
            description
            initialSupply
            price
            artworkExtension
            artworkUrl
            chainId
            wallet
            quantityPurchased
            timesPurchased
            transactionHash
            tokenUri
            isFirstTimeBuy
            bought
            isRegisterForAirDrop
          }
          email
          wallet
          status
          airdropDate
          claimedDate
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_FORUMS = gql`
 query Query($orderBy: ForumOrderByInput!, $first: Int) {
  forumList(orderBy: $orderBy, first: $first) {
    edges {
      cursor
      node {
        id
        name
        description
        createdAt
        updatedAt
        isDeleted
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
`;

export const GET_POST_APPROVAL_LIST = gql`
query PostList($orderBy: PostOrderByInput!, $filters: PostWhereInput, $after: String, $before: String, $first: Int, $last: Int) {
  postList(orderBy: $orderBy, filters: $filters, after: $after, before: $before, first: $first, last: $last) {
    edges {
      cursor
      node {
        id
        userId {
          id
          fullName
          username
          name
          email
        }
        profileKey
        profileTitle
        refId
        type
        scheduleDate
        platforms
        post
        youTubeOptions {
          title
          thumbnail
        }
        pinterestOptions {
          title
          thumbnail
        }
        mediaUrls
        mediaIcons
        errors
        status
        approvalStatus
        isVideo
        createdAt
        updatedAt
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
`;


export const GET_POST_APPROVAL_BY_ID = gql`
query Post($postId: String) {
  post(id: $postId) {
    id
    userId {
      id
      fullName
      username
      name
      email
      description
      mobile
      address
      countryCode
      profilePic
      coverPic
      wallet
      profile_img
      createdAt
      socialLinks {
        facebook
        twitter
        instagram
        blog
        website
        discord
      }
      isVerified
      isBlocked
      isBanned
      isProfileDetailsUpdated
      isWhitelisted
      isRequestForwhitelist
      isCollectionAccess
      collectionAccessStatus
      rejectReason
      isRequestedCollectionAccess
      tags
      totalVolume
      totalCollections
      totalNfts
      floorPrice
      isPublic
      wallets {
        addr
        provider
      }
      isDistroApproved
    }
    profileKey
    profileTitle
    refId
    type
    scheduleDate
    platforms
    post
    youTubeOptions {
      title
      thumbnail
    }
    pinterestOptions {
      title
      thumbnail
    }
    mediaUrls
    mediaIcons
    errors
    status
    approvalStatus
    isVideo
    createdAt
    updatedAt
  }
}
`

export const GET_LEAD_LIST = gql`
 query LeadList($page: Int!, $pageSize: Int!, $orderBy: LeadOrderByInput, $filters: LeadWhereInput) {
  leadList(page: $page, pageSize: $pageSize, orderBy: $orderBy, filters: $filters) {
      edges {
        cursor
        node {
          id
          first_name
          last_name
          createdFor
          username
          email
          phone
          createdAt
          updatedAt
          platform
          isPositive
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
        currentPage
        totalPages
        totalCount
        pageSize
      }
    }
  }
`;

;

export const GET_CLUSTER_LIST = gql`
  query LeadListData($filters: LeadListWhereInput) {
    leadListData(filters: $filters) {
      items {
        id
        organization_id
        has_enrichment_task
        owned_by
        name
        timestamp_created
      }
      next_starting_after
    }
  }
`;

;

export const GET_LIST_FROM_CLUSTER = gql`
  query GetListFromLeadList($filters: LeadListFromLeadListWhereInput) {
    getListFromLeadList(filters: $filters) {
      status
      message
      data {
        items {
          id
          status
          esp_code
          email_reply_count
          timestamp_created
          timestamp_updated
          email
          last_name
          first_name
          phone
          list_id
        }
        next_starting_after
      }
    }
  }
`;

export const GET_CAMPAIGN_LIST = gql`
  query CampaignList($filters: CampaignWhereInput) {
  campaignList(filters: $filters) {
    items {
      id
      owned_by
      name
      timestamp_created
      timestamp_updated
      stop_on_auto_reply
      status
      campaign_schedule {
        start_date
        end_date
      }
    }
    next_starting_after
  }
}
`;

export const GET_BUCKET_DETAILS = gql`
  query GetBucketDetails {
    bucketDetails {
      name
      cap
      vestedAmount
      releasedAmount
      cliffMonths
      vestingMonths
    }
  }
`;

export const GET_MAX_AVAILABLE_TOKEN = gql`
  query MaxAvailableToken {
    maxAvailableToken
  }
`;

export const GET_TGE_TIMESTAMP = gql`
  query GetTgeTimestamp {
    tgeTimestamp
  }
`;

export const GET_VESTING_LIST = gql`
  query VestingList(
    $orderBy: VestingOrderByInput!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $filters: VestingWhereInput
  ) {
    vestingList(
      orderBy: $orderBy
      after: $after
      before: $before
      first: $first
      last: $last
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          type
          vestingId
          email
          walletAddress
          totalTokens
          claimedTokens
          nextClaimDate
          createdAt
          updatedAt
          transactionHash
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_ACCOUNT_LIST = gql`
  query AccountList($filters: AccountWhereInput) {
    accountList(filters: $filters) {
      status
      message
      data {
        items {
          id
          email
        }
        next_starting_after
      }
    }
  }
`;

export const GET_CAMPAIGN = gql`
query CampaignGet($campaignGetId: String!) {
  campaignGet(id: $campaignGetId) {
    message
    status
    data {
      bcc_list
      cc_list
      disable_bounce_protect
      allow_risky_contacts
      insert_unsubscribe_header
      stop_for_company
      match_lead_esp
      auto_variant_select {
        trigger
      }
      prioritize_new_leads
      daily_max_leads
      stop_on_auto_reply
      open_tracking
      link_tracking
      email_tag_list
      stop_on_reply
      daily_limit
      email_list
      text_only
      random_wait_max
      email_gap
      timestamp_updated
      timestamp_created
      id
      organization_id
      has_enrichment_task
      owned_by
      name
      pl_value
      status
      is_evergreen
      campaign_schedule {
        start_date
        end_date
        schedules {
          name
          timing {
            from
            to
          }
          days {
            sunday
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
          }
          timezone
        }
      }
      sequences {
        steps {
          type
          delay
          variants {
            subject
            body
            v_disabled
          }
        }
      }
      organization
    }
  }
}
  `;

// export const GET_CAMPAIGNS_ANALYTICS_STEP = gql`
//   query CampaignsAnalyticsStep($filters: CampaignsAnalyticsStepWhereInput) {
//     campaignsAnalyticsStep(filters: $filters) {
//       status
//       message
//       data {
//         step
//         variant
//         sent
//         opened
//         unique_opened
//         replies
//         unique_replies
//         clicks
//         unique_clicks
//       }
//     }
//   }
// `;


export const GET_CAMPAIGNS_ANALYTICS_STEP = gql`
  query CampaignsAnalyticsStep($filters: CampaignsAnalyticsStepWhereInput) {
  campaignsAnalyticsStep(filters: $filters) {
    status
    message
    data {
      step
      sent
      opened
      unique_opened
      replies
      unique_replies
      clicks
      unique_clicks
      opportunities
      opened_percentage
      replies_percentage
      clicks_percentage
      variants {
        variant
        sent
        opened
        unique_opened
        replies
        unique_replies
        clicks
        unique_clicks
        opportunities
        opened_percentage
        replies_percentage
        clicks_percentage
      }
    }
  }
}
`;

export const GET_CAMPAIGNS_ANALYTICS_DAILY = gql`
  query CampaignsAnalyticsDaily($filters: CampaignsAnalyticsDailyWhereInput) {
    campaignsAnalyticsDaily(filters: $filters) {
      status
      message
      data {
        date
        sent
        opened
        unique_opened
        replies
        unique_replies
        clicks
        unique_clicks
      }
    }
  }
`;

export const GET_CAMPAIGNS_ANALYTICS = gql`
  query CampaignsAnalytics($filters: CampaignsAnalyticsWhereInput) {
    campaignsAnalytics(filters: $filters) {
      status
      message
      data {
        campaign_name
        campaign_id
        campaign_status
        campaign_is_evergreen
        leads_count
        contacted_count
        open_count
        reply_count
        link_click_count
        bounced_count
        unsubscribed_count
        completed_count
        emails_sent_count
        new_leads_contacted_count
        total_opportunities
        total_opportunity_value
      }
    }
  }
`;

export const GET_LIST_FROM_INFLUENCERS = gql`
  query GetListFromInfluencers($filters: InfluencersWhereInput) {
    getListFromInfluencers(filters: $filters) {
      message
      status
    }
  }
`;

export const GET_ESTIMATION_OF_INFLUENCERS = gql`
  query GetEstimationOfInfluencers($filters: InfluencersWhereInput) {
    getEstimationOfInfluencers(filters: $filters) {
      message
      status
      total
    }
  }
`;

export const GET_PROFILE = gql`
  query GetProfile($filters: InfluencerProfileWhereInput) {
    getProfile(filters: $filters) {
      message
      status
    }
  }
`;

// export const ACTIVITY_EMAIL_LIST = gql`
//   query ActivityEmailList($filters: InstantlyWhereInput) {
//     activityEmailList(filters: $filters) {
//       message
//       status
//       data {
//         items {
//           id
//           timestamp_created
//           timestamp_email
//           message_id
//           subject
//           to_address_email_list
//           body {
//             text
//             html
//           }
//           organization_id
//           eaccount
//           from_address_email
//           campaign_id
//           lead
//           ue_type
//           step
//           is_unread
//           is_focused
//           thread_id
//           content_preview
//           from_address_json {
//             address
//             name
//           }
//           to_address_json {
//             address
//             name
//           }
//         }
//         next_starting_after
//       }
//     }
//   }
// `;


export const ACTIVITY_EMAIL_LIST = gql`
 query ActivityEmailList($filters: InstantlyWhereInput) {
  activityEmailList(filters: $filters) {
    message
    status
    data {
      items {
        id
        timestamp_created
        timestamp_email
        message_id
        subject
        to_address_email_list
        body {
          text
          html
        }
        organization_id
        eaccount
        from_address_email
        cc_address_email_list
        bcc_address_email_list
        reply_to
        reminder_ts
        campaign_id
        subsequence_id
        list_id
        lead
        lead_id
        ue_type
        step
        is_unread
        is_auto_reply
        ai_interest_value
        ai_assisted
        is_focused
        i_status
        thread_id
        content_preview
        attachment_json {
          filename
          size
          type
          url
          error
        }
        ai_agent_id
      }
      next_starting_after
    }
  }
}
`;

export const EXPORT_LIST_FROM_LEAD_LIST = gql`
 query ExportListFromLeadList($filters: LeadListFromLeadListWhereInput) {
  exportListFromLeadList(filters: $filters) {
    status
    message
    publicUrl
  }
}
`;

export const GET_LEAD = gql`
  query Lead($leadId: String!) {
  lead(id: $leadId) {
    id
    first_name
    last_name
    email
    phone
    createdAt
    updatedAt
    isAILead
    isEmailVerified
    platform
    username
    isPositive
        instagram {
      id
      userid
      engagement_percent
      uses_link_in_bio
      full_name
      income {
        min
        max
        currency
      }
      creator_follower_growth {
        six_months_ago
        twelve_months_ago
        three_months_ago
        nine_months_ago
      }
      hashtags
      follower_count
      niche_class
      posting_frequency_recent_months
      biography
      username
      exists
      profile_picture
      is_private
      is_business_account
      is_verified
      media_count
      following_count
      video_content_creator
      most_recent_post_date
      locations
      reels_percentage_last_12_posts
      reels {
        avg_like_count
        avg_view_count
        comments_count
        median_like_count
        median_view_count
      }
      email
      email_type
      links_in_bio
      youtube
      youtube_link
      tiktok
      engagement_percent_source
   
      has_merch
      promotes_affiliate_links
      avg_likes
      avg_comments
      likes_median
      comments_median
      has_profile_pic
      streamer
      related_platforms {
        youtube_main
        youtube
        tiktok_main
        tiktok
      }
      language_code
      language_confidence
      profile_picture_hd
      post_data {
        post_id
        created_at
        caption
        post_url
        hashtags
        media {
          media_id
          type
          url
        }
        engagement {
          likes
          comments
          shares
          views
          saves
        }
      }
      tagged {
        user_id
        username
      }
      hashtags_count {
        name
        count
      }
    }
    youtube {
      id
      has_community_posts
      engagement_percent
      youtube_id
      uses_link_in_bio
      custom_url
      income {
        min
        max
        currency
      }
      description
      title
      niche_class
      video_hashtags
      posting_frequency_recent_months
      first_name
      avg_views
      subscriber_count
      video_count
      view_count
      exists
      published_at
      country
      profile_picture
      related_playlist_id
      topic_details
      made_for_kids
      privacy_status
      moderate_comments
      unsubscribed_trailer_id
      keywords
      recording_location
      video_categories
      video_topics
      has_shorts
      last_long_video_upload_date
      last_short_video_upload_date
      least_views
      related_platforms {
        instagram_main
        instagram
        tiktok_main
        tiktok
        twitter_main
        twitter
      }
      avg_likes
      avg_comments
      total_comments_last_50
      median_views_long
      avg_views_long
      avg_views_shorts
      engagement_percent_shorts
      engagement_percent_long
      engagement_by_comments_and_views_long
      engagement_by_comments_and_views_shorts
      engagement_by_likes_and_views_long
      engagement_by_likes_and_views_shorts
      engagement_by_views_and_subs_long
      engagement_by_views_and_subs_shorts
      shorts_percentage
      engagement_percent_source
      email_from_video_desc
      posting_frequency
      posting_frequency_long
      posting_frequency_shorts
      link
      language_code
      language_confidence
      hashtags_count {
        name
        count
      }
      has_paid_partnership
      promotes_affiliate_links
      streamer
      location_certainty
      profile_picture_hd
      post_data {
        video_id
        title
        description
        published_at
        category_id
        default_language
        default_audio_language
        engagement {
          view_count
          like_count
          comment_count
          favorite_count
        }
        post_url
        media {
          duration
          definition
          embed_html
          thumbnails {
            default
            medium
            high
            standard
            maxres
          }
        }
      }
      most_recent_post_date
      location
      video_tags
    }
     twitter {
      id
      hashtags
      userid
      follower_count
      avg_likes
      engagement_percent
      tweets_frequency_recent_months
      biography
      full_name
      username
      join_date
      links_in_bio
      following_count
      media_count
      tweets_count
      is_verified
      direct_messaging
      location
      profile_picture
      creator_favorite_count
      most_recent_post_date
      tweets
      tweets_type {
        ordinary
        retweeted
        conversation
        quoted
      }
      recommended_users
      retweet_users
      subscriber_button
      super_followed_by
      exists
      retweets_count
      languages_tweet
      avg_views
      avg_quotes
      avg_reply
      avg_retweet
      engagement_percent_source
      uses_link_in_bio
      has_paid_partnership
      promotes_affiliate_links
      has_merch
      streamer
      country
      location_source
      location_certainty
      language_confidence
      language_code
      platforms {
        twitter
      }
      profile_picture_hd
      post_data {
        tweet_id
        created_at
        text
        lang
        engagement {
          like_count
          retweet_count
          reply_count
          quote_count
          view_count
        }
        media {
          media_id
          type
          url
        }
        tweet_url
        hashtags
      }
      hashtags_count {
        name
        count
      }
    }
    twitch {
      id
      username
      description
      displayName
      isPartner
      profileImageURL
      total_followers
      panels_urls
      panels_descriptions
      panels_titles
      panels_type
      panels_image
      social_media {
        tiktok
        instagram
        twitter
      }
      user_id
      last_broadcast_game
      last_broadcast_id
      primary_team_display_name
      primary_team_name
      other_links
      links_in_bio
      streamed_hours_last_30_days
      streams_count_last_30_days
      has_merch
      promotes_affiliate_links
      has_paid_partnership
      tagged
      related_platforms {
        youtube_main
        youtube
        instagram_main
        instagram
        tiktok_main
        tiktok
        twitter_main
        twitter
      }
      language_confidence
      language_code
      profile_picture_hd
      post_data {
        post_id
        created_at
        caption
        post_url
        hashtags
        media {
          media_id
          type
          url
        }
        engagement {
          likes
          comments
          shares
          views
          saves
        }
      }
    }
    onlyfans {
      id
      avg_likes
      engagement_percent
      posting_frequency_recent_months
      first_name
      biography
      user_id
      username
      profile_picture
      full_name
      is_verified
      subscribe_price
      join_date
      links_in_bio
      posts_count
      photos_count
      videos_count
      audios_count
      media_count
      last_seen
      total_likes
      is_real_performer
      is_adult_content
      finished_streams_count
      can_create_promotion
      tips_enabled
      tips_text_enabled
      tips_min
      tips_min_internal
      tips_max
      can_earn
      archived_posts_count
      private_archived_posts_count
      is_spotify_connected
      referal_bonus_sum_for_referer
      can_receive_chat_message
      can_chat
      first_published_post_date
      exists
      post_dates
      uses_link_in_bio
      avg_comments
      comments_median
      has_paid_partnership
      instagram
      engagement_percent_source
      has_merch
      promotes_affiliate_links
      streamer
      likes_median
      twitter
      related_platforms {
        twitter_main
        twitter
        instagram_main
        instagram
      }
      language_confidence
      language_code
      profile_picture_hd
    }
    lookalikes {
      id
      username
      profile_url
      engagement_percent
      follower_count
      isAdded
    }
    tiktok {
      id
      has_merch
      avg_likes
      engagement_percent
      uses_link_in_bio
      full_name
      user_id
      hashtags
      creator_follower_growth {
        six_months_ago
        three_months_ago
      }
      follower_count
      niche_class
      posting_frequency_recent_months
      biography
      username
      exists
      profile_picture
      sec_user_id
      tt_seller
      is_ad
      is_verified
      is_commerce
      duet_setting
      is_private
      following_count
      video_count
      region
      saves_count_list
      tagged
      challenges_list
      reach_score_list
      additional_info {
        ins_id
        youtube_channel_id
        youtube_channel_title
      }
      links_in_bio
      total_likes
      mention_status
      engagement_percent_source
      email
      email_type
      brands_found
      paid_partnership
      promotes_affiliate_links
      most_recent_post_date
      likes_median
      comment_count_avg
      comments_median
      duration_avg
      play_count_avg
      play_count_median
      reach_score
      total_shares
      total_saves
      shares_median
      saves_median
      streamer
      related_platforms {
        instagram_main
        instagram
        youtube_ids_main
        youtube_ids
      }
      language_code
      language_confidence
      posting_frequency
      profile_picture_hd
      post_data {
        post_id
        created_at
        caption
        post_url
        hashtags
        media {
          media_id
          type
          url
        }
        engagement {
          likes
          comments
          shares
          views
          saves
        }
        
      }
    }
  }
}
`;


export const GET_INSTANTLY_LEAD_COUNT = gql`
query CountLeads($filters: LeadListFromLeadListWhereInput) {
  countLeads(filters: $filters) {
    message
    status
    total
  }
}`

export const DELETE_BY_LIST = gql`
  query DeleteByList($orderBy: LeadOrderByInput, $filters: LeadWhereInput) {
    deleteByList(orderBy: $orderBy, filters: $filters) {
      message
      status
      deletedCount
    }
  }
`;

export const ADMIN_ICO_LIST = gql`
  query AdminIcoList(
    $orderBy: AdminIcoOrderByInput!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $filters: AdminIcoWhereInput
  ) {
    adminIcoList(
      orderBy: $orderBy
      after: $after
      before: $before
      first: $first
      last: $last
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          type
          currency
          amount
          tokens
          transactionHash
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const ICO_TOKEN = gql`
  query IcoToken {
    icoToken {
      status
      message
      data {
        id
        name
        description
        startDate
        endDate
        softCap
        hardCap
        tokenSymbol
        tokenRate
        totalTokensSold
        totalRaisedUSDT
        totalRaisedUSDC
        totalRaisedETH
        status
        result
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;

export const ICO_DETAILS = gql`
  query Ico {
    ico {
      status
      message
      data {
        icoDetails {
          id
          name
          description
          startDate
          endDate
          softCap
          hardCap
          tokenSymbol
          tokenRate
          totalTokensSold
          totalRaisedUSDT
          totalRaisedUSDC
          totalRaisedETH
          status
          result
          isActive
          createdAt
          updatedAt
        }
        balance {
          eth
          usdc
          usdt
          token
        }
      }
    }
  }
`;

export const ICO_TRANSACTION_LIST = gql`
  query IcoTransactionList(
    $orderBy: IcoTransactionOrderByInput!
    $filters: IcoTransactionWhereInput!
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    icoTransactionList(
      orderBy: $orderBy
      filters: $filters
      after: $after
      before: $before
      first: $first
      last: $last
    ) {
      edges {
        cursor
        node {
          id
          walletAddress
          userId
          icoId
          currency
          amount
          tokens
          transactionHash
          type
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const TOKEN_PER_POINT = gql`
  query TokenPerPoint {
    tokenPerPoint {
      status
      message
      data
      gildAddress
    }
  }
`;

export const TOKEN_PER_POINT_TRANSACTION_LIST = gql`
  query TokenPerPointTransactionList(
    $orderBy: TokenPriceTransactionOrderByInput!
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    tokenPerPointTransactionList(
      orderBy: $orderBy
      after: $after
      before: $before
      first: $first
      last: $last
    ) {
      edges {
        cursor
        node {
          id
          amount
          transactionHash
          timestamp
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const ECOSYSTEM_STATUS = gql`
  query EcosystemStatus {
    ecosystemStatus {
      status
      message
      data {
        status
        date
        hasCliffEnded
      }
    }
  }
`;

export const TRANSFER_TOKEN_TO_CONTRACT = gql`
  query TransferTokenToContract {
    transferTokenToContract {
      status
      message
      data
    }
  }
`;

// Camaroo User Management
export const GET_CAMAROO_USERS = gql`
  query Users(
    $orderBy: UserOrderByInput!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $filters: UserWhereInput
  ) {
    users(
      orderBy: $orderBy
      after: $after
      before: $before
      first: $first
      last: $last
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          fullName
          role
          profilePicture
          coverPicture
          category
          gender
          mobile
          city
          state
          email
          address
          location {
            type
            place
            coordinates
          }
          workLocations {
            type
            place
            coordinates
          }
          notificationSetting {
            portfolio
            opportunity
            application
            marketplace
            subscribe
            subscription
            course
            chat
            referral
          }
          socialMediaLinks {
            instagram
            youtube
            website
            other
          }
          businessDetails {
            businessLogo
            businessName
            watermark
            digitalSignature
            gstNumber
          }
          privacySetting {
            portfolioVisibility
            showEmail
            showPhone
            showLocation
          }
          yearsOfExperience
          specialization
          signUpType
          isProfileCompleted
          isBlocked
          firebaseUid
          lastActivity
          subscriberCount
          isDeleted
          isEmailVerified
          pushToken
          referralCode
          deviceId
          hasClaimedReferralReward
          referralRewardClaimedAt
          appTheme
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_CAMAROO_USERS_NEXT = gql`
  query Users(
    $orderBy: UserOrderByInput!
    $after: String
    $first: Int
    $filters: UserWhereInput
  ) {
    users(
      orderBy: $orderBy
      after: $after
      first: $first
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          fullName
          role
          profilePicture
          coverPicture
          category
          gender
          mobile
          city
          state
          email
          address
          location {
            type
            place
            coordinates
          }
          workLocations {
            type
            place
            coordinates
          }
          notificationSetting {
            portfolio
            opportunity
            application
            marketplace
            subscribe
            subscription
            course
            chat
            referral
          }
          socialMediaLinks {
            instagram
            youtube
            website
            other
          }
          businessDetails {
            businessLogo
            businessName
            watermark
            digitalSignature
            gstNumber
          }
          privacySetting {
            portfolioVisibility
            showEmail
            showPhone
            showLocation
          }
          yearsOfExperience
          specialization
          signUpType
          isProfileCompleted
          isBlocked
          firebaseUid
          lastActivity
          subscriberCount
          isDeleted
          isEmailVerified
          pushToken
          referralCode
          deviceId
          hasClaimedReferralReward
          referralRewardClaimedAt
          appTheme
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_CAMAROO_USERS_PREV = gql`
  query Users(
    $orderBy: UserOrderByInput!
    $before: String
    $last: Int
    $filters: UserWhereInput
  ) {
    users(
      orderBy: $orderBy
      before: $before
      last: $last
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          fullName
          role
          profilePicture
          coverPicture
          category
          gender
          mobile
          city
          state
          email
          address
          location {
            type
            place
            coordinates
          }
          workLocations {
            type
            place
            coordinates
          }
          notificationSetting {
            portfolio
            opportunity
            application
            marketplace
            subscribe
            subscription
            course
            chat
            referral
          }
          socialMediaLinks {
            instagram
            youtube
            website
            other
          }
          businessDetails {
            businessLogo
            businessName
            watermark
            digitalSignature
            gstNumber
          }
          privacySetting {
            portfolioVisibility
            showEmail
            showPhone
            showLocation
          }
          yearsOfExperience
          specialization
          signUpType
          isProfileCompleted
          isBlocked
          firebaseUid
          lastActivity
          subscriberCount
          isDeleted
          isEmailVerified
          pushToken
          referralCode
          deviceId
          hasClaimedReferralReward
          referralRewardClaimedAt
          appTheme
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

// Camaroo User Portfolios
export const GET_USER_PORTFOLIOS = gql`
  query UserPortfolios(
    $userId: String!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $orderBy: PortfolioOrderByInput!
    $filters: PortfolioWhereInput
  ) {
    userPortfolios(
      userId: $userId
      after: $after
      before: $before
      first: $first
      last: $last
      orderBy: $orderBy
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          userId
          title
          description
          mediaUrls {
            name
            url
            mediaType
          }
          coverUrls {
            name
            url
            mediaType
          }
          tags
          visibility
          likeCount
          commentCount
          isActive
          isDeleted
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_USER_PORTFOLIOS_NEXT = gql`
  query UserPortfolios(
    $userId: String!
    $after: String
    $first: Int
    $orderBy: PortfolioOrderByInput!
    $filters: PortfolioWhereInput
  ) {
    userPortfolios(
      userId: $userId
      after: $after
      first: $first
      orderBy: $orderBy
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          userId
          title
          description
          mediaUrls {
            name
            url
            mediaType
          }
          coverUrls {
            name
            url
            mediaType
          }
          tags
          visibility
          likeCount
          commentCount
          isActive
          isDeleted
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_USER_PORTFOLIOS_PREV = gql`
  query UserPortfolios(
    $userId: String!
    $before: String
    $last: Int
    $orderBy: PortfolioOrderByInput!
    $filters: PortfolioWhereInput
  ) {
    userPortfolios(
      userId: $userId
      before: $before
      last: $last
      orderBy: $orderBy
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          userId
          title
          description
          mediaUrls {
            name
            url
            mediaType
          }
          coverUrls {
            name
            url
            mediaType
          }
          tags
          visibility
          likeCount
          commentCount
          isActive
          isDeleted
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

// Camaroo User Opportunities
export const GET_USER_OPPORTUNITIES = gql`
  query UserOpportunities(
    $userId: String!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $orderBy: OpportunityOrderByInput!
    $filters: OpportunityWhereInput
  ) {
    userOpportunities(
      userId: $userId
      after: $after
      before: $before
      first: $first
      last: $last
      orderBy: $orderBy
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          userId
          title
          description
          startDate
          endDate
          location
          status
          type
          category
          shootType
          reference {
            name
            url
            mediaType
          }
          postType
          role
          eventType
          eventTime
          budget
          experienceRequired
          equipmentRequired
          experience
          dayRate
          equipmentOwned
          travelAvailability
          bio
          portfolioLink
          isDeleted
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_USER_OPPORTUNITIES_NEXT = gql`
  query UserOpportunities(
    $userId: String!
    $after: String
    $first: Int
    $orderBy: OpportunityOrderByInput!
    $filters: OpportunityWhereInput
  ) {
    userOpportunities(
      userId: $userId
      after: $after
      first: $first
      orderBy: $orderBy
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          userId
          title
          description
          startDate
          endDate
          location
          status
          type
          category
          shootType
          reference {
            name
            url
            mediaType
          }
          postType
          role
          eventType
          eventTime
          budget
          experienceRequired
          equipmentRequired
          experience
          dayRate
          equipmentOwned
          travelAvailability
          bio
          portfolioLink
          isDeleted
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_USER_OPPORTUNITIES_PREV = gql`
  query UserOpportunities(
    $userId: String!
    $before: String
    $last: Int
    $orderBy: OpportunityOrderByInput!
    $filters: OpportunityWhereInput
  ) {
    userOpportunities(
      userId: $userId
      before: $before
      last: $last
      orderBy: $orderBy
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          userId
          title
          description
          startDate
          endDate
          location
          status
          type
          category
          shootType
          reference {
            name
            url
            mediaType
          }
          postType
          role
          eventType
          eventTime
          budget
          experienceRequired
          equipmentRequired
          experience
          dayRate
          equipmentOwned
          travelAvailability
          bio
          portfolioLink
          isDeleted
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

// Camaroo Opportunity Applications
export const GET_OPPORTUNITY_APPLICATIONS = gql`
  query OpportunityApplications(
    $opportunityId: String!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $orderBy: ApplicationOrderByInput!
    $filters: ApplicationWhereInput
  ) {
    opportunityApplications(
      opportunityId: $opportunityId
      after: $after
      before: $before
      first: $first
      last: $last
      orderBy: $orderBy
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          opportunityId
          userId
          status
          message
          reason
          appliedAt
          reviewedAt
          reviewedBy
          canceledAt
          isCancelByApplicant
          applicant {
            id
            fullName
            email
            mobile
            profilePicture
          }
          reviewer {
            id
            fullName
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_OPPORTUNITY_APPLICATIONS_NEXT = gql`
  query OpportunityApplications(
    $opportunityId: String!
    $after: String
    $first: Int
    $orderBy: ApplicationOrderByInput!
    $filters: ApplicationWhereInput
  ) {
    opportunityApplications(
      opportunityId: $opportunityId
      after: $after
      first: $first
      orderBy: $orderBy
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          opportunityId
          userId
          status
          message
          reason
          appliedAt
          reviewedAt
          reviewedBy
          canceledAt
          isCancelByApplicant
          applicant {
            id
            fullName
            email
            mobile
            profilePicture
          }
          reviewer {
            id
            fullName
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_OPPORTUNITY_APPLICATIONS_PREV = gql`
  query OpportunityApplications(
    $opportunityId: String!
    $before: String
    $last: Int
    $orderBy: ApplicationOrderByInput!
    $filters: ApplicationWhereInput
  ) {
    opportunityApplications(
      opportunityId: $opportunityId
      before: $before
      last: $last
      orderBy: $orderBy
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          opportunityId
          userId
          status
          message
          reason
          appliedAt
          reviewedAt
          reviewedBy
          canceledAt
          isCancelByApplicant
          applicant {
            id
            fullName
            email
            mobile
            profilePicture
          }
          reviewer {
            id
            fullName
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

// Camaroo User Course Purchases
export const GET_USER_COURSE_PURCHASES = gql`
  query UserCoursePurchases(
    $userId: String!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $orderBy: CoursePurchaseOrderByInput!
  ) {
    userCoursePurchases(
      userId: $userId
      after: $after
      before: $before
      first: $first
      last: $last
      orderBy: $orderBy
    ) {
      edges {
        cursor
        node {
          id
          userId
          courseId
          price
          course {
            id
            name
            description
            type
            tag
            image {
              name
              url
            }
            videos {
              title
              description
              mediaUrl
              thumbnailUrl
              duration
            }
            isActive
            isDeleted
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_USER_COURSE_PURCHASES_NEXT = gql`
  query UserCoursePurchases(
    $userId: String!
    $after: String
    $first: Int
    $orderBy: CoursePurchaseOrderByInput!
  ) {
    userCoursePurchases(
      userId: $userId
      after: $after
      first: $first
      orderBy: $orderBy
    ) {
      edges {
        cursor
        node {
          id
          userId
          courseId
          price
          course {
            id
            name
            description
            type
            tag
            image {
              name
              url
            }
            videos {
              title
              description
              mediaUrl
              thumbnailUrl
              duration
            }
            isActive
            isDeleted
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

// Camaroo User Subscriptions
export const GET_USER_SUBSCRIPTIONS_BY_USER = gql`
  query UserSubscriptionsByUser(
    $userId: String!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $orderBy: UserSubscriptionOrderByInput!
    $filters: UserSubscriptionByUserWhereInput
  ) {
    userSubscriptionsByUser(
      userId: $userId
      after: $after
      before: $before
      first: $first
      last: $last
      orderBy: $orderBy
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          userId
          subscriptionId
          status
          razorpaySubscriptionId
          startDate
          endDate
          isFree
          isCancelled
          grantedVia
          data
          usage
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_USER_SUBSCRIPTIONS_BY_USER_NEXT = gql`
  query UserSubscriptionsByUser(
    $userId: String!
    $after: String
    $first: Int
    $orderBy: UserSubscriptionOrderByInput!
    $filters: UserSubscriptionByUserWhereInput
  ) {
    userSubscriptionsByUser(
      userId: $userId
      after: $after
      first: $first
      orderBy: $orderBy
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          userId
          subscriptionId
          status
          razorpaySubscriptionId
          startDate
          endDate
          isFree
          isCancelled
          grantedVia
          data
          usage
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_USER_SUBSCRIPTIONS_BY_USER_PREV = gql`
  query UserSubscriptionsByUser(
    $userId: String!
    $before: String
    $last: Int
    $orderBy: UserSubscriptionOrderByInput!
    $filters: UserSubscriptionByUserWhereInput
  ) {
    userSubscriptionsByUser(
      userId: $userId
      before: $before
      last: $last
      orderBy: $orderBy
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          userId
          subscriptionId
          status
          razorpaySubscriptionId
          startDate
          endDate
          isFree
          isCancelled
          grantedVia
          data
          usage
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

// Camaroo User Marketplaces
export const GET_USER_MARKETPLACES = gql`
  query UserMarketplaces(
    $userId: String!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $orderBy: MarketplaceOrderByInput!
    $filters: MarketplaceWhereInput
  ) {
    userMarketplaces(
      userId: $userId
      after: $after
      before: $before
      first: $first
      last: $last
      orderBy: $orderBy
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          userId
          productName
          type
          status
          category
          brand
          series
          productModel
          productType
          customProductName
          condition
          sellerType
          price
          rentStartDate
          rentEndDate
          location {
            type
            place
            coordinates
          }
          city
          state
          description
          images {
            name
            url
            mediaType
          }
          purchaseYear
          billAvailable
          warrantyAvailable
          reasonForSelling
          securityDeposit
          availableQuantity
          pickupDeliveryOption
          rentalTerms
          includedAccessories
          isDeleted
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_USER_MARKETPLACES_NEXT = gql`
  query UserMarketplaces(
    $userId: String!
    $after: String
    $first: Int
    $orderBy: MarketplaceOrderByInput!
    $filters: MarketplaceWhereInput
  ) {
    userMarketplaces(
      userId: $userId
      after: $after
      first: $first
      orderBy: $orderBy
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          userId
          productName
          type
          status
          category
          brand
          series
          productModel
          productType
          customProductName
          condition
          sellerType
          price
          rentStartDate
          rentEndDate
          location {
            type
            place
            coordinates
          }
          city
          state
          description
          images {
            name
            url
            mediaType
          }
          purchaseYear
          billAvailable
          warrantyAvailable
          reasonForSelling
          securityDeposit
          availableQuantity
          pickupDeliveryOption
          rentalTerms
          includedAccessories
          isDeleted
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_USER_MARKETPLACES_PREV = gql`
  query UserMarketplaces(
    $userId: String!
    $before: String
    $last: Int
    $orderBy: MarketplaceOrderByInput!
    $filters: MarketplaceWhereInput
  ) {
    userMarketplaces(
      userId: $userId
      before: $before
      last: $last
      orderBy: $orderBy
      filters: $filters
    ) {
      edges {
        cursor
        node {
          id
          userId
          productName
          type
          status
          category
          brand
          series
          productModel
          productType
          customProductName
          condition
          sellerType
          price
          rentStartDate
          rentEndDate
          location {
            type
            place
            coordinates
          }
          city
          state
          description
          images {
            name
            url
            mediaType
          }
          purchaseYear
          billAvailable
          warrantyAvailable
          reasonForSelling
          securityDeposit
          availableQuantity
          pickupDeliveryOption
          rentalTerms
          includedAccessories
          isDeleted
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_USER_COURSE_PURCHASES_PREV = gql`
  query UserCoursePurchases(
    $userId: String!
    $before: String
    $last: Int
    $orderBy: CoursePurchaseOrderByInput!
  ) {
    userCoursePurchases(
      userId: $userId
      before: $before
      last: $last
      orderBy: $orderBy
    ) {
      edges {
        cursor
        node {
          id
          userId
          courseId
          price
          course {
            id
            name
            description
            type
            tag
            image {
              name
              url
            }
            videos {
              title
              description
              mediaUrl
              thumbnailUrl
              duration
            }
            isActive
            isDeleted
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

// Camaroo Subscriptions (flat list)
export const GET_SUBSCRIPTIONS_LIST = gql`
  query Subscriptions {
    subscriptions {
      id
      name
      slug
      description
      stripeProductId
      stripePriceId
      price
      duration
      isOnRazorpay
      features
      isActive
      isDeleted
      createdAt
      updatedAt
    }
  }
`;

// ===================== Camaroo Courses =====================

export const GET_COURSES = gql`
  query Courses(
    $orderBy: CourseOrderByInput!
    $filters: CourseWhereInput
    $last: Int
    $first: Int
    $before: String
    $after: String
  ) {
    courses(
      orderBy: $orderBy
      filters: $filters
      last: $last
      first: $first
      before: $before
      after: $after
    ) {
      edges {
        cursor
        node {
          id
          name
          description
          type
          tag
          price
          videos {
            id
            title
            description
            mediaUrl
            thumbnailUrl
            duration
          }
          image {
            name
            url
          }
          isActive
          isDeleted
          owner
          createdBy {
            id
            fullName
            email
          }
          updatedBy {
            id
            fullName
            email
          }
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_COURSE_DETAILS = gql`
  query Course($courseId: String!) {
    course(id: $courseId) {
      id
      name
      description
      type
      tag
      price
      videos {
        id
        title
        description
        mediaUrl
        thumbnailUrl
        duration
      }
      image {
        name
        url
      }
      isActive
      isDeleted
      owner
      createdBy {
        id
        fullName
        email
      }
      updatedBy {
        id
        fullName
        email
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_COURSE_INQUIRIES = gql`
  query CourseInquiries(
    $orderBy: CourseInquiryOrderByInput!
    $filters: CourseInquiryWhereInput
    $last: Int
    $first: Int
    $before: String
    $after: String
  ) {
    courseInquiries(
      orderBy: $orderBy
      filters: $filters
      last: $last
      first: $first
      before: $before
      after: $after
    ) {
      edges {
        cursor
        node {
          id
          title
          message
          email
          mobile
          status
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const GET_COURSE_INQUIRY_DETAILS = gql`
  query CourseInquiry($courseInquiryId: String!) {
    courseInquiry(id: $courseInquiryId) {
      id
      title
      message
      email
      mobile
      status
      createdAt
      updatedAt
    }
  }
`;

export const GET_COURSE_PURCHASES = gql`
  query CoursePurchases(
    $orderBy: CoursePurchaseOrderByInput!
    $filters: CoursePurchaseWhereInput
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    coursePurchases(
      orderBy: $orderBy
      filters: $filters
      after: $after
      before: $before
      first: $first
      last: $last
    ) {
      edges {
        cursor
        node {
          id
          userId
          courseId
          price
          user {
            id
            fullName
          }
          course {
            id
            name
          }
          createdAt
          updatedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

// Full app-user detail by id (matches the User type the User Details page renders)
export const GET_USER_BY_ID = gql`
  query UserDetail($userId: String!) {
    user(id: $userId) {
      id
      fullName
      role
      profilePicture
      coverPicture
      category
      gender
      mobile
      city
      state
      email
      address
      location {
        type
        place
        coordinates
      }
      workLocations {
        type
        place
        coordinates
      }
      notificationSetting {
        portfolio
        opportunity
        application
        marketplace
        subscribe
        subscription
        course
        chat
        referral
      }
      socialMediaLinks {
        instagram
        youtube
        website
        other
      }
      businessDetails {
        businessLogo
        businessName
        watermark
        digitalSignature
        gstNumber
      }
      privacySetting {
        portfolioVisibility
        showEmail
        showPhone
        showLocation
      }
      yearsOfExperience
      specialization
      signUpType
      isProfileCompleted
      isBlocked
      firebaseUid
      lastActivity
      subscriberCount
      isDeleted
      isEmailVerified
      pushToken
      referralCode
      deviceId
      hasClaimedReferralReward
      referralRewardClaimedAt
      appTheme
      createdAt
      updatedAt
    }
  }
`;
